import React, { useEffect, useState } from "react";
import Select from 'react-select';
import { styleSelect } from "../../../constants/customStyles";
import moment from "moment/moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { saveJobCard, savePerformaInvoice } from "../../../actions/JobCardActions";
import Dropzone, { useDropzone } from 'react-dropzone';
import Toast from "../../../components/Toast";
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Scrollbar } from "swiper";
import { ThreeDots } from "react-loader-spinner";

function JobOutModal(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { modalJobCardId, jobCard } = props;
    const loading = useSelector(state => state?.loading?.addEditLoading);

    const [jobOut, setJobOut] = useState({});
    const [jobCardNo, setJobCardNo] = useState('');
    const [estimateDetails, setEstimateDetails] = useState({});
    const [modelJobCard1, setModalJobCard1] = useState([]);
    const [previewImagesJobOut, setPreviewImagesJobOut] = useState([]);
    const [estimateId, setEstimateId] = useState('');

    useEffect(() => {
        if (jobCard) {
            setModalJobCard1(jobCard)
        }
    }, [jobCard])

    useEffect(() => {
        if (Object.keys(modelJobCard1).length > 0) {
            const preloadImages = modelJobCard1.images.reduce((accumulator, image) => {
                const imageObject = {
                    preview: image.image_path + '/' + image.file_name,
                    default: 0,
                    id: image.job_card_image_id,
                };

                if (image.type === 'jobOut') {
                    return { ...accumulator, jobOutFiles: [...accumulator.jobOutFiles, imageObject] };
                } else {
                }

                return accumulator;
            }, { files: [], jobOutFiles: [] });

            setJobOutFiles(preloadImages.jobOutFiles);
            setPreviewImagesJobOut(preloadImages.jobOutFiles);
        }
    }, [modelJobCard1]);

    useEffect(() => {
        if (modelJobCard1 && Object.keys(modelJobCard1).length > 0) {
            setEstimateDetails(modelJobCard1)
            setJobOut({
                job_out: modelJobCard1?.job_out,
                km_out: modelJobCard1?.km_out,
                lump_sum: modelJobCard1?.lump_sum,
                out_mobile: modelJobCard1?.out_mobile,
                discount_amount: modelJobCard1?.discount_amount,
                vat_amount: modelJobCard1?.vat_amount,
                discount_percentage: modelJobCard1?.discount_percentage,
                vat_percentage: modelJobCard1?.vat_percentage,
                total_amount: modelJobCard1?.total_amount,
                grand_total: modelJobCard1?.grand_total,
            })
            setEstimateId(modelJobCard1.estimate_id ?? null)
            if (modelJobCard1 && modelJobCard1.job_card_details) {
                const updatedDetails = modelJobCard1.job_card_details.map((detail) => {
                    const vatPercentage = 5; // Fixed vat_percentage
                    let vatAmount = 0;
                    let totalAmount = 0;

                    if (!detail.price_sold) {
                        vatAmount = (detail.sale_price * detail.quantity * vatPercentage) / 100;
                        totalAmount = detail.sale_price * detail.quantity + vatAmount;
                    } else {
                        vatAmount = (detail.price_sold * detail.quantity * vatPercentage) / 100;
                        totalAmount = detail.price_sold * detail.quantity + vatAmount;
                    }

                    return {
                        ...detail,
                        vat_percentage: vatPercentage,
                        vat_amount: parseFloat(vatAmount),
                        total_amount: parseFloat(totalAmount).toFixed(2),
                    };
                });

                let sumOftotalAmount = 0;
                updatedDetails.forEach((detail) => {
                    sumOftotalAmount += parseFloat(detail.total_amount);
                });

                setEstimateDetails((prevDetails) => ({
                    ...prevDetails,
                    job_card_details: updatedDetails,
                    total_amount: parseFloat(sumOftotalAmount).toFixed(2),
                }));

                const totalVatPercentage = 5; // Fixed vat_percentage
                const totalVatAmount = parseFloat(sumOftotalAmount * totalVatPercentage) / 100;
                let grandTotalAmount = parseFloat(sumOftotalAmount + totalVatAmount);

                setJobOut({
                    ...jobOut,
                    vat_percentage: totalVatPercentage,
                    vat_amount: parseFloat(totalVatAmount).toFixed(2),
                    grand_total: parseFloat(grandTotalAmount).toFixed(2),
                    total_amount: parseFloat(sumOftotalAmount).toFixed(2),
                });
            }
        }
    }, [modelJobCard1])

    // 'job out', modalJobCard);
    const handleChangeJobOut = (event) => {
        setJobOut({
            ...jobOut,
            estimate_id: estimateId,
            [event.target.name]: event.target.value,
        });
        // 'formData', jobIn);
    };
    const saveJobOut = async () => {
        if (!jobOut.km_out) {
            Toast.fire({
                icon: 'error',
                title: 'KM Out is Required!'
            })
        } else if (!jobOut.out_mobile) {
            Toast.fire({
                icon: 'error',
                title: 'Out Mobile is Required!'
            })
        }
        else {
            let data = {
                // jobIn: jobIn
                jobOut: jobOut,
                imageId: removeImageJobOut,
                estimate_id: estimateId
                // details: details
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in jobOutFiles) {
                formData1.append('images[]', jobOutFiles[key])
            }
            await dispatch(saveJobCard(formData1, navigate));
        }
        await navigate('/jobCard')
    }

    const savePerforma = async () => {
        if (jobOut.km_out == null) {
            Toast.fire({
                icon: 'error',
                title: 'KM Out is Required!'
            })
        } else if (!jobOut.out_mobile) {
            Toast.fire({
                icon: 'error',
                title: 'Out Mobile is Required!'
            })
        }
        else {
            let data = {
                jobOut: jobOut,
                imageId: removeImageJobOut,
                estimate_id: estimateId
            }
            let formData1 = new FormData();
            formData1.append('data', JSON.stringify(data));
            for (var key in jobOutFiles) {
                formData1.append('images[]', jobOutFiles[key])
            }
            dispatch(saveJobCard(formData1));
            // 'job out', estimateId);
            await dispatch(savePerformaInvoice(data, navigate));
            await navigate('/jobCard')
        }
    }

    const [jobOutFiles, setJobOutFiles] = useState([]);
    const [removeImageJobOut, setRemoveImageJobOut] = useState([]);

    const thumbsContainer = {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: 16
    };

    const thumb = {
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 15,
        width: 100,
        height: 100,
        padding: 4,
        boxSizing: 'border-box'
    };

    const thumbInner = {
        display: 'block',
        minWidth: 92,
        overflow: 'hidden'
    };

    const img = {
        display: 'block',
        width: 'auto',
        height: '100%'
    };

    const { getRootProps: getRootPropsJobOut, getInputProps: getInputPropsJobOut } = useDropzone({
        maxFiles: 30,
        accept: '.jpeg,.png,.jpg',
        maxSize: 5000000,
        onDropAccepted: acceptedFiles => {
            if (jobOutFiles && jobOutFiles.length == 1) {
                setJobOutFiles(jobOutFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    default: (index == 0) ? 1 : 0
                }))));
            } else {
                if (acceptedFiles.length + jobOutFiles.length > 30) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Maximum 30 Images Allowed',
                    });
                } else {
                    setJobOutFiles(jobOutFiles.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        default: 0
                    }))));
                }
            }
        },
        onDropRejected: rejectedFiles => {
            if (rejectedFiles.length > 0) {
                let error = 'There was an error';
                if (rejectedFiles[0].errors[0].code == 'file-invalid-type') {
                    error = 'File Format Not Supported';
                } else if (rejectedFiles[0].errors[0].code == 'file-too-large') {
                    error = 'Image Size greater than 5mb'
                } else if (rejectedFiles[0].errors[0].code == 'too-many-files') {
                    error = 'Maximum 30 Images Allowed';
                }
                // setDropzoneError(rejectedFiles[0].errors[0].message);
                Toast.fire({
                    icon: 'error',
                    title: error,
                });
            }
        }
    });
    const removeImage = (file, index) => {
        const updatedFiles = [...jobOutFiles];

        if (index === 0 && file.default === 1) {
            updatedFiles[1].default = 1;
        } else if (index !== 0 && file.default === 1) {
            updatedFiles[0].default = 1;
        }
        let imageIds = [];

        if (updatedFiles[index].id) {

            imageIds = updatedFiles[index].id;
            setRemoveImageJobOut([
                ...removeImageJobOut,
                imageIds
            ]);

        }

        updatedFiles.splice(index, 1);

        setJobOutFiles(updatedFiles);
    }
    const [dropzoneTitle, setDropZoneTitle] = useState("Please Upload Photos");
    const jobOutThumbs = jobOutFiles.length > 0 && jobOutFiles.map((file, index) => {
        return (
            <React.Fragment key={index + 1}>
                <SwiperSlide>
                    <div>
                        <div style={thumb} className={`${file.default == 1 ? "default-image" : ''}`} key={file.name}>
                            <div style={thumbInner}>
                                <img
                                    src={file.preview}
                                    style={img}
                                />
                            </div>
                        </div>
                        <span class="image-close" onClick={() => removeImage(file, index, 'jobOut')}>&times;</span>
                    </div>
                </SwiperSlide>
            </React.Fragment>
        )
    }
    );

    // Function to calculate discounted amount, discount percentage, VAT amount, and grand total
    const calculateDiscountAndVAT = (totalAmount, discountPercentage, vatPercentage, vatAmount) => {
        const discountPercent = parseFloat(discountPercentage) / 100;
        const vatPercent = parseFloat(vatPercentage) / 100;

        const discountAmount = totalAmount * discountPercent;
        const discountedTotalAmount = totalAmount - discountAmount;

        let calculatedVATAmount = 0;

        if (vatPercentage) {
            calculatedVATAmount = totalAmount * vatPercent;
        } else if (vatAmount) {
            calculatedVATAmount = vatAmount;
        }

        const grandTotal = discountedTotalAmount + calculatedVATAmount;

        return {
            discountAmount: parseFloat(discountAmount.toFixed(2)),
            discountedTotalAmount: parseFloat(discountedTotalAmount.toFixed(2)),
            vatAmount: parseFloat(calculatedVATAmount.toFixed(2)),
            grandTotal: parseFloat(grandTotal.toFixed(2)),
        };
    };



    // Function to handle discount percentage change
    const handleTotalDiscountPercentageChange = (e) => {
        const discountPercentage = parseFloat(e.target.value.replace('%', '')) || 0;

        // Call the calculateDiscountAndVAT function
        const { discountAmount, discountedTotalAmount, vatAmount, grandTotal } = calculateDiscountAndVAT(
            estimateDetails.total_amount,
            discountPercentage,
            jobOut.vat_percentage || 0
        );

        // Update jobOut state with the new values
        setJobOut({
            ...jobOut,
            discount_percentage: discountPercentage,
            discount: discountAmount,
            // total_amount: discountedTotalAmount,
            vat: vatAmount,
            grand_total: grandTotal.toFixed(2),
        });
    };

    // Function to handle discount amount change
    const handleTotalDiscountAmountChange = (e) => {
        const discountAmount = parseFloat(e.target.value) || 0;

        // Calculate discount percentage
        const discountPercentage = ((discountAmount / estimateDetails.total_amount) * 100).toFixed(2);

        // Call the calculateDiscountAndVAT function
        const { discountedTotalAmount, vatAmount, grandTotal } = calculateDiscountAndVAT(
            estimateDetails.total_amount,
            discountPercentage,
            jobOut.vat_percentage || 0
        );

        // Update jobOut state with the new values
        setJobOut({
            ...jobOut,
            discount_percentage: discountPercentage,
            discount: discountAmount,
            // total_amount: discountedTotalAmount,
            vat: vatAmount,
            grand_total: grandTotal.toFixed(2),
        });
    };

    // Function to handle VAT percentage change
    const handleTotalVATPercentageChange = (e) => {
        const vatPercentage = parseFloat(e.target.value.replace('%', '')) || 0;

        // Call the calculateDiscountAndVAT function
        const { discountAmount, discountedTotalAmount, vatAmount, grandTotal } = calculateDiscountAndVAT(
            estimateDetails.total_amount,
            jobOut.discount_percentage || 0,
            e.target.value.replace('%', '') || 0
        );

        // Update jobOut state with the new values
        setJobOut({
            ...jobOut,
            vat_percentage: e.target.value.replace('%', ''),
            vat: vatAmount,
            // total_amount: discountedTotalAmount,
            discount: discountAmount,
            grand_total: grandTotal.toFixed(2),
        });
    };

    // Function to handle VAT amount change
    const handleTotalVATAmountChange = (e) => {
        const vatAmount = parseFloat(e.target.value) || 0;

        const vatPercentage = ((vatAmount / estimateDetails.total_amount) * 100).toFixed(2);

        // Check if estimateDetails is defined
        if (estimateDetails) {
            // Call the calculateDiscountAndVAT function
            const { discountAmount, discountedTotalAmount, grandTotal } = calculateDiscountAndVAT(
                estimateDetails.total_amount || 0,
                jobOut.discount_percentage || 0,
            );

            // Update jobOut state with the new values
            setJobOut({
                ...jobOut,
                vat_percentage: vatPercentage,
                vat: vatAmount,
                // total_amount: discountedTotalAmount,
                discount: discountAmount,
                grand_total: grandTotal.toFixed(2),
            });
        }
    };

    const calculateTotalAmount = (details) => {
        let totalAmount = 0;
        details.forEach((detail) => {
            totalAmount += parseFloat(detail.total_amount);
        });
        setJobOut({
            // ...estimateDetails,
            total_amount: totalAmount,
        })
    };

    const handleChangeLumSum = (event) => {
        setJobOut({
            ...jobOut,
            lump_sum: event.target.checked
        })
    };

    return (
        <React.Fragment>
            {/* Edit Vehicle Modal */}
            <div id="jobOut-modal" className="modal fade" tabindex="-1" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div className="modal-header">
                            <h2 className="fw-medium fs-base me-auto">Job Out</h2>
                        </div>
                        {/* </div> <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="modal-body">
                            {
                                loading ?
                                    <ThreeDots
                                        height="80"
                                        width="80"
                                        radius="9"
                                        color="#2d3748"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                        wrapperClassName=""
                                        visible={loading}
                                    /> :
                                    <span>
                                        <div className="intro-y">
                                            <div className="px-5 mt-6 pb-5">
                                                <div className="g-col-sm-12 d-flex justify-content-end">
                                                    {
                                                        modalJobCardId && modalJobCardId?.lpo_claim_id ?
                                                            <span>
                                                                <button type="button" onClick={savePerforma} className="btn btn-primary me-2">Create Performa Invoice</button>
                                                                <button onClick={saveJobOut} type="button" className="btn btn-primary w-32 ">Save</button>
                                                            </span>
                                                            :
                                                            <span className="text-end">
                                                                <h3 className="fs-base text-theme-6 bg-theme-6-light border border-theme-6 p-3 rounded-2 mb-2">
                                                                    LPO Doesnot Exists.
                                                                </h3>
                                                                <button onClick={saveJobOut} type="button" className="btn btn-primary w-32 ">Submit</button>
                                                            </span>
                                                    }
                                                    {/* <button type="button" className="btn btn-primary w-32 me-1">Print Invoice</button> */}
                                                    {/* <button type="button" className="btn btn-primary w-32 me-1">Print Job Card</button>
                                                    <button type="button" className="btn btn-primary w-32 me-1">Print Estimate</button> */}
                                                </div>
                                                <div className="grid columns-12">
                                                    <div className="g-col-12 g-col-sm-12 d-flex justify-content-end align-items-center">
                                                        {/* <h2 className="intro-y fs-lg fw-medium ms-2">
                                                                    Repairs :
                                                                </h2> */}
                                                        {/* <div className="text-end mt-2">
                                                                    <h4 className="text-gray-700">Estimated Profit Margin = AED { parseFloat(estimateDetails?.estimate_total_amount) - parseFloat(estimateDetails.total_amount) ?? 0 }</h4>
                                                                </div> */}
                                                    </div>
                                                    {/* <div className="intro-y g-col-12 g-col-sm-1">
                                                    <div className="intro-y g-col-12 g-col-sm-2 d-flex flex-column justify-items-center">
                                                        <label for="job_out" className="form-label">Job Out<span className="text-theme-6">*</span> :</label>
                                                        <div className="mt-2">
                                                            <div className="form-check form-switch"> <input id="job_out" value={jobOut?.job_out} name="job_out" className="form-check-input" type="checkbox" /></div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                    <div className="intro-y g-col-12 g-col-sm-6">
                                                        <label for="km_out" className="form-label">KM Out<span className="text-theme-6">*</span> :</label>
                                                        <input id="km_out" value={jobOut?.km_out} onChange={handleChangeJobOut} name="km_out" type="number" className="form-control" placeholder="Enter Km Out" />
                                                        <label for="out_mobile" className="form-label mt-3">Out Mobile<span className="text-theme-6">*</span> :</label>
                                                        <input id="out_mobile" value={jobOut?.out_mobile} onChange={handleChangeJobOut} name="out_mobile" type="text" className="form-control" placeholder="Enter Out Mobile" />
                                                        <div className="mt-2">
                                                            <label for="lump_sum" className="form-label">Lump Sum :</label>
                                                            <div className="form-check form-switch"> <input id="checkbox-switch-7" checked={jobOut?.lump_sum == "1" ? true : false} name="lumpSum" onChange={handleChangeLumSum} className="form-check-input" type="checkbox" /></div>
                                                        </div>
                                                        {/* </div>
                                                <div className="intro-y g-col-12 g-col-sm-3"> */}
                                                    </div>
                                                    <div className="intro-y g-col-12 g-col-sm-6">
                                                        <label for="image" className="form-label">Image:</label>
                                                        <section className="container text-center form-control">
                                                            <aside style={thumbsContainer} className="justify-content-center mb-0">
                                                                {
                                                                    (jobOutFiles.length == 0) &&
                                                                    <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                                                }
                                                                <Swiper
                                                                    slidesPerView={4}
                                                                    scrollbar={{
                                                                        hide: true,
                                                                    }}
                                                                    grid={{
                                                                        rows: 1,
                                                                    }}
                                                                    modules={[Grid, Scrollbar]}
                                                                    className="mySwiper h-full"
                                                                >
                                                                    {jobOutThumbs}
                                                                </Swiper>
                                                            </aside>
                                                            <div {...getRootPropsJobOut({ className: 'dropzone p-2' })}>
                                                                <input {...getInputPropsJobOut()} />
                                                                <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                                                <div className="btn btn-primary w-25 mt-2">Upload Photos</div>
                                                            </div>
                                                        </section>
                                                    </div>
                                                    {/* <div className="intro-y g-col-12 g-col-sm-4">
                                                    <label for="pay_type" className="form-label">Pay Type<span className="text-theme-6">*</span> :</label>
                                                    <Select styles={styleSelect} value={selectedPayType} onChange={handleChangePayType} name="pay_type" options={[{ value: 1, label: "Cash" }, { value: 2, label: "Cheque" }, { value: 3, label: "Bank Transfer" }]} />
                                                </div> */}
                                                    <div className="intro-y g-col-12 g-col-sm-12">
                                                        <div class="overflow-x-auto border my-5 border-gray-600 rounded-3">
                                                            <table class="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th class="text-nowrap">S. No</th>
                                                                        {/* <th class="text-nowrap">Consumed On</th> */}
                                                                        <th class="text-nowrap">Item</th>
                                                                        <th class="text-nowrap">Price (AED)</th>
                                                                        {/* <th class="text-nowrap">Selling Price(AED)</th> */}
                                                                        <th class="text-nowrap">Quantity</th>
                                                                        {/* <th class="text-nowrap">Discount (%)</th>
                                                                                <th class="text-nowrap">Discount (AED)</th>
                                                                                <th class="text-nowrap">VAT (%)</th>
                                                                                <th class="text-nowrap">VAT (AED)</th> */}
                                                                        <th class="text-nowrap">Total Amount (AED)</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        estimateDetails && Object.keys(estimateDetails).length > 0 && estimateDetails.job_card_details &&
                                                                        estimateDetails?.job_card_details.map((detail, index) => {

                                                                            // const handleDiscountPercentageChange = (e) => {
                                                                            //     const discountPercentage = parseFloat(e.target.value.replace('%', '')) || 0;
                                                                            //     const discountedAmount = parseFloat((detail.sale_price * detail.quantity * discountPercentage) / 100);
                                                                            //     const totalAmount = Math.max(detail.total_amount - discountedAmount, 0);
                                                                            //     let previousTotalAmount;
                                                                            //     if (!detail.discount_amount) {
                                                                            //         previousTotalAmount = detail.sale_price * detail.quantity + detail.vat_amount;
                                                                            //     } else {
                                                                            //         previousTotalAmount = detail.sale_price * detail.quantity + detail.vat_amount;
                                                                            //     }
                                                                            //     if (isNaN(discountPercentage) || e.target.value === '') {
                                                                            //         // If discountPercentage is NaN or empty, set it to 0 and recalculate
                                                                            //         const updatedDetails = [...estimateDetails.job_card_details];
                                                                            //         updatedDetails[index] = {
                                                                            //             ...detail,
                                                                            //             discount_percentage: 0,
                                                                            //             discount_amount: 0,
                                                                            //             total_amount: parseFloat(previousTotalAmount).toFixed(2), // Revert to original total amount
                                                                            //         };

                                                                            //         calculateTotalAmount(updatedDetails);
                                                                            //         setEstimateDetails({
                                                                            //             ...estimateDetails,
                                                                            //             job_card_details: updatedDetails,
                                                                            //         });
                                                                            //     } else if (detail.total_amount < discountedAmount) {
                                                                            //         Toast.fire({
                                                                            //             icon: 'error',
                                                                            //             title: 'Discounted amount exceeds total amount!',
                                                                            //         });
                                                                            //     } else {
                                                                            //         // Update the specific detail object in the array
                                                                            //         const updatedDetails = [...estimateDetails.job_card_details];
                                                                            //         updatedDetails[index] = {
                                                                            //             ...detail,
                                                                            //             discount_percentage: discountPercentage,
                                                                            //             discount_amount: parseFloat(discountedAmount),
                                                                            //             total_amount: parseFloat(totalAmount).toFixed(2),
                                                                            //         };
                                                                            //         calculateTotalAmount(updatedDetails);
                                                                            //         // Update the state with the modified details array
                                                                            //         setEstimateDetails({
                                                                            //             ...estimateDetails,
                                                                            //             job_card_details: updatedDetails,
                                                                            //         });
                                                                            //     }
                                                                            // };

                                                                            // const handleDiscountAmountChange = (e) => {
                                                                            //     const discountAmount = parseFloat(e.target.value) || 0;
                                                                            //     const discountPercentage = parseFloat((discountAmount / detail.total_amount) * 100).toFixed(2);
                                                                            //     const totalAmount = Math.max(detail.total_amount - discountAmount, 0);
                                                                            //     let previousTotalAmount;
                                                                            //     if (!detail.vat_amount) {
                                                                            //         previousTotalAmount = detail.sale_price * detail.quantity;
                                                                            //     } else {
                                                                            //         previousTotalAmount = detail.sale_price * detail.quantity + detail.vat_amount;
                                                                            //     }
                                                                            //     if (isNaN(discountAmount) || e.target.value === '') {
                                                                            //         // If discountAmount is NaN or empty, set it to 0 and recalculate
                                                                            //         const updatedDetails = [...estimateDetails.job_card_details];
                                                                            //         updatedDetails[index] = {
                                                                            //             ...detail,
                                                                            //             discount_percentage: 0,
                                                                            //             discount_amount: 0,
                                                                            //             total_amount: parseFloat(previousTotalAmount).toFixed(2), // Revert to original total amount
                                                                            //         };
                                                                            //         calculateTotalAmount(updatedDetails);
                                                                            //         setEstimateDetails({
                                                                            //             ...estimateDetails,
                                                                            //             job_card_details: updatedDetails,
                                                                            //         });
                                                                            //     } else if (detail.total_amount < discountAmount) {
                                                                            //         Toast.fire({
                                                                            //             icon: 'error',
                                                                            //             title: 'Discounted amount exceeds total amount!',
                                                                            //         });
                                                                            //     } else {
                                                                            //         // Update the specific detail object in the array
                                                                            //         const updatedDetails = [...estimateDetails.job_card_details];
                                                                            //         updatedDetails[index] = {
                                                                            //             ...detail,
                                                                            //             discount_percentage: discountPercentage,
                                                                            //             discount_amount: parseFloat(discountAmount),
                                                                            //             total_amount: parseFloat(totalAmount).toFixed(2),
                                                                            //         };
                                                                            //         calculateTotalAmount(updatedDetails);
                                                                            //         // Update the state with the modified details array
                                                                            //         setEstimateDetails({
                                                                            //             ...estimateDetails,
                                                                            //             job_card_details: updatedDetails,
                                                                            //         });
                                                                            //     }
                                                                            // };


                                                                            return (
                                                                                <tr key={detail.product_id}>
                                                                                    <td>{index + 1}</td>
                                                                                    {/* <td>{moment(detail?.created_at).format('DD-MM-YYYY')}</td> */}
                                                                                    <td className="w-full">{detail?.product_name}</td>
                                                                                    <td>{detail?.price_sold}</td>
                                                                                    <td>x {detail?.quantity}</td>
                                                                                    {/* <td>
                                                                                                <input
                                                                                                    id={`discount-${detail.product_id}`}
                                                                                                    name="discount_percentage"
                                                                                                    type="text"
                                                                                                    value={detail.discount_percentage ? detail.discount_percentage : ''}
                                                                                                    className="form-control w-24"
                                                                                                    placeholder="Discount (%)"
                                                                                                    onChange={handleDiscountPercentageChange}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    id={`discount-${detail.product_id}`}
                                                                                                    name="discount"
                                                                                                    type="text"
                                                                                                    value={detail.discount_amount ? detail.discount_amount : ''}
                                                                                                    className="form-control w-24"
                                                                                                    placeholder="Discount.."
                                                                                                    onChange={handleDiscountAmountChange}
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                5%
                                                                                            </td>
                                                                                            <td>
                                                                                                {detail?.vat_amount}
                                                                                            </td> */}
                                                                                    <td>{detail?.total_amount}</td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    }
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <th className="text-end" colSpan={4}>Total Amount Before Vat (AED)</th>
                                                                        <td>{jobOut?.total_amount ? jobOut?.total_amount : estimateDetails.total_amount}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-end" colSpan={2}>Discount (%)</th>
                                                                        <td>
                                                                            <input
                                                                                id="discount"
                                                                                name="discount_percentage"
                                                                                value={jobOut.discount_percentage ? jobOut.discount_percentage : ''}
                                                                                type="text"
                                                                                className="form-control w-28"
                                                                                placeholder="Discount (%)"
                                                                                onChange={handleTotalDiscountPercentageChange}
                                                                            />
                                                                        </td>
                                                                        <th className="text-end">Discount (AED)</th>
                                                                        <td>
                                                                            <input
                                                                                id="discount"
                                                                                name="discount"
                                                                                value={jobOut.discount ? jobOut.discount : ''}
                                                                                type="text"
                                                                                className="form-control w-28"
                                                                                placeholder="Discount.."
                                                                                onChange={handleTotalDiscountAmountChange}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-end" colSpan={2}>Total Vat (%)</th>
                                                                        <td>
                                                                            {jobOut.vat_percentage ? jobOut.vat_percentage : ''}
                                                                        </td>
                                                                        <th className="text-end">Total Vat (AED)</th>
                                                                        <td>
                                                                            {jobOut.vat_amount ? jobOut.vat_amount : ''}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th className="text-end" colSpan={4}>Grand Total (AED)</th>
                                                                        <td>{jobOut.grand_total}</td>
                                                                    </tr>
                                                                </tfoot>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                            }
                        </div>
                        {/* <!-- END: Modal Body --> */}
                    </div>
                </div>
            </div>
            {/*End Edit Vehicle Modal */}
        </React.Fragment>
    )
}

export default JobOutModal;